module.exports = __webpack_public_path__ + "media/images/company/cp06-47fb4356a74fe391650773e36651e1a6.png";